import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { siteCollection } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Sites{" "}
    <Link className="button" to="/admin/platform/newsrpm-marketplace/site/new">
      New Site
    </Link>
  </Fragment>
);

export default function SitesPage(): ReactNode {
  return (
    <PageLayout title="NewsRPM Parser - Sites">
      <PaginatedList title={title} collection={siteCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Network</th>
              <th>Site Name</th>
              <th>URL</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, network, siteName, url }) => (
              <tr key={id}>
                <td>{network}</td>
                <td>{siteName}</td>
                <td>{url}</td>
                <td>
                  <Link to={`/admin/platform/newsrpm-marketplace/site/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
